$.widget("custom.mypagespopover", {
    options: {},
    _create: function () {
        $('[data-toggle="popover"]', this.element).popover();  
    }
});